import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { zip } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '@appstore/*';
import { getDriver, getDriverName } from '@appstore/*';

@Injectable({
    providedIn: 'root'
})
/**
 * @deprecated Can only be removed once all end points have been refactored.
 */
export class LegacyDriverNameInterceptor implements HttpInterceptor {

    private driverNameId: number;
    // TODO: use constants from rest.service
    private urlsArrPayload: string[] = [
        '/tour-stop-tracking',
        '/shift/edit',
        '/tour-stop-tracking/edit',
        '/shift-break/edit',
        '/actions-status-cancel',
        '/actions-status-update',
        '/checklist',
        '/tour-stop-tracking',
    ];
    private urlsObjPayload: string[] = [
        '/shift/start',
        '/shift/stop',
        '/fuel-refill',
        '/sign-submit-protocols',
        '/upsert-driver-note',
        '/delete-driver-note'
    ];

    constructor(
        private store: Store<AppState>
    ) {
        zip(
            this.store.select(getDriverName),
            this.store.select(getDriver),
        ).subscribe(([driverName, driver]) => {
            const requiresName = driver?.sharedAccount
            this.driverNameId = (requiresName && driverName && driverName.id) ? driverName.id : null;
        });
    }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        let newReq: HttpRequest<any>;

        if ((req.method === 'POST' || req.method === 'PUT' || req.method === 'DELETE') && this.driverNameId) {
            const newReqBody = this.interceptBody(req.body, req.url);
            newReq = req.clone({
                body: newReqBody
            });
            return next.handle(newReq);
        }

        return next.handle(req);
    }

    // TODO: rename driverId to driverNameId (and also fix on backend)
    public interceptBody(payload: any, fullUrl: string) {
        if (this.urlsArrPayload.some(url => fullUrl.includes(url))) {
            return payload.map(elem => ({
                ...elem,
                // DEPRECATED
                // TODO: stop using driverId where it's actually a driverNameId
                driverId: this.driverNameId,
                driverNameId: this.driverNameId,
            }));

        } else if (this.urlsObjPayload.some(url => fullUrl.includes(url))) {
            return {
                ...payload,
                // DEPRECATED
                // TODO: stop using driverId where it's actually a driverNameId
                driverId: this.driverNameId,
                driverNameId: this.driverNameId,
            };

        } else {
            return payload;
        }

    }
}
